<template>
  <router-view/>
</template>

<style lang="scss">
@import "assets/css/index";

html, body, #app {
  width: 100%;
  height: 100%;
}
</style>
